module.exports = __webpack_public_path__ + "fec2537d.png";